@if(formMetaData && formFieldsToUse){

<mat-card>
    <mat-card-header style="position: relative;">
        <mat-card-title>
            Patient Admission Form
        </mat-card-title>
        <mat-card-subtitle>
            Please fill the form below to admit the patient
        </mat-card-subtitle>
        <button mat-icon-button class="close-button" (click)="closeDialog()" matTooltip="Close dialog"
            style="position: absolute; top: 8px; right: 8px; z-index: 100;">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-header>
    <mat-card-content>
        <div class="forms">
            <div class="form-segment">
                <div class="segment-title my-15">

                </div>
                <app-dynamic-forms-v2 [formFields]="formFieldsToUse.encounter.formFields" [formMetaData]="undefined"
                    (onEveryChange)="onEncounterFormChange($event)"></app-dynamic-forms-v2>
            </div>
            <div class="form-segment mt-20">
                <!-- <div class="segment-title my-15">
                    Bed Allocation
                </div>
                <app-dynamic-forms-v2 [formFields]="formFieldsToUse.encounter.location"
                    [formMetaData]="undefined"></app-dynamic-forms-v2> -->


                @if(formFieldsToUse.location && locationForm) {
                <mat-card>
                    <mat-card-header>

                        <mat-card-title>

                            Allocate BedSpace to Patient

                        </mat-card-title>
                        <mat-card-subtitle class="g-just-flex gap-12" style="align-items: center;">
                            <span>Choose a ward, room and bed.</span>
                            @if(formFieldsToUse.location.formFields[2]?.data?.length >= 0) {
                            <span class="small-chips status-success g-just-flex gap-8"
                                style="padding: 4px 12px; font-size: 12px;">
                                <mat-icon style="font-size: 16px; width: 16px; height: 16px;">hotel</mat-icon>
                                <span>{{ formFieldsToUse.location.formFields[2]?.data?.length || 0 }} Available
                                    Beds</span>
                            </span>
                            }
                        </mat-card-subtitle>

                    </mat-card-header>

                    <mat-card-content>
                        <form [formGroup]="locationForm" class="mt-20 aform">
                            <!-- Ward -->

                            <mat-form-field appearance="outline" class="me-30 mb-20" floatLabel="always">
                                <mat-label>Ward</mat-label>
                                <input type="text" formControlName="ward" [matAutocomplete]="auc" matInput>
                                <mat-autocomplete #auc="matAutocomplete" [displayWith]="displayDisplay">
                                    @for(value of (wardFormFilter | async) || []; track $index){
                                    <mat-option [value]="value">
                                        <div class="ticket-like">
                                            <div class="text">
                                                {{value?.display | titlecase}}
                                            </div>
                                            <div class="code">
                                                {{value?.reference}}
                                            </div>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-autocomplete>

                            </mat-form-field>
                            <!-- Room -->
                            <mat-form-field appearance="outline" class="me-30 mb-20" floatLabel="always">
                                <mat-label>Room</mat-label>
                                <input type="text" formControlName="room" [matAutocomplete]="auc2" matInput #roomInput>
                                <mat-autocomplete #auc2="matAutocomplete" [displayWith]="displayDisplay">
                                    @for(value of (roomFormFilter | async) || []; track $index){
                                    <mat-option [value]="value">
                                        <div class="ticket-like">
                                            <div class="text">
                                                {{value?.display | titlecase}}
                                            </div>
                                            <div class="code">
                                                {{value?.reference}}
                                            </div>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                            <!-- Bed -->
                            <mat-form-field appearance="outline" class="me-30 mb-20" floatLabel="always">
                                <mat-label>Bed</mat-label>
                                <input type="text" formControlName="bed" [matAutocomplete]="auc3" matInput #bedInput>
                                <mat-autocomplete #auc3="matAutocomplete" [displayWith]="displayDisplay">
                                    @for(value of (bedFormFilter | async) || []; track $index){
                                    <mat-option [value]="value">
                                        <div class="ticket-like">
                                            <div class="text">
                                                {{value?.display | titlecase}}
                                            </div>
                                            <div class="code">
                                                {{value?.reference}}
                                            </div>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </form>
                    </mat-card-content>
                </mat-card>

                }

            </div>

            <!-- Submit Admission Button Section -->
            <div class="submit-admission-section my-20">
                <mat-divider></mat-divider>

                <div class="g-just-flex justify-content-between align-items-center my-20">
                    <div class="left-info">
                        <h3 class="mat-subtitle-1" style="margin: 0;">Ready to Submit Admission?</h3>
                        <p class="mat-body-2 subtitle-text-color-2" style="margin: 4px 0 0 0;">
                            Submit the admission now. You can optionally add a care plan afterwards.
                        </p>
                    </div>

                    <div class="right-actions">
                        <button mat-flat-button (click)="submitEncounter()" [disabled]="submittingAdmission">
                            @if (!submittingAdmission) {
                            <ng-container>
                                <mat-icon class="me-8" style="vertical-align: sub;">check_circle</mat-icon>
                                Submit Admission
                            </ng-container>
                            } @else {
                            <ng-container>
                                <mat-icon>
                                    <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
                                </mat-icon>
                                <span>Submitting...</span>
                            </ng-container>
                            }
                        </button>
                    </div>
                </div>

                <mat-divider></mat-divider>
            </div>

            <!-- Toggle Care Plan Button (only show after admission is submitted) -->
            @if (admissionSubmitted) {
            <div class="action my-15">
                <button mat-raised-button (click)="showCarePlanForm = !showCarePlanForm">
                    <mat-icon>{{showCarePlanForm ? 'remove' : 'add'}}</mat-icon>
                    <span>{{showCarePlanForm ? 'Hide Care Plan' : 'Add A Care Plan'}}</span>
                </button>
            </div>
            }

            <!-- Care Plan Section (Only after admission is submitted) -->
            @if (showCarePlanForm && admissionSubmitted) {
            <div class="care-plan-section my-20">
                <app-care-plan-form [carePlanFormFields]="formFieldsToUse"
                    [admissionSubmitted]="admissionSubmitted">
                </app-care-plan-form>
            </div>
            }

            @if (showCarePlanForm && !admissionSubmitted) {
            <div class="care-plan-locked-section my-20">
                <div class="info-banner"
                    style="padding: 16px; background: var(--mat-sys-surface-variant); border-radius: 8px; border-left: 4px solid var(--mat-sys-primary);">
                    <div class="g-just-flex gap-12 align-items-start">
                        <mat-icon class="subtitle-text-color-2" style="margin-top: 2px;">lock</mat-icon>
                        <div>
                            <div class="mat-subtitle-2" style="margin-bottom: 4px; font-weight: 500;">Care Plan Locked
                            </div>
                            <span class="mat-body-2 subtitle-text-color-2">
                                Please submit the admission first to enable care plan creation.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            }

        </div>
    </mat-card-content>
</mat-card>
}